import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import {
  PRODUCT_MANAGER_LIST_INIT,
  PRODUCT_MANAGER_GET_PRODUCT_LIST_BEGIN,
  PRODUCT_MANAGER_GET_PRODUCT_LIST_SUCCESS,
  PRODUCT_MANAGER_GET_PRODUCT_LIST_FAIL,
  PRODUCT_MANAGER_POST_PRODUCT_LIST_BEGIN,
  PRODUCT_MANAGER_POST_PRODUCT_LIST_SUCCESS,
  PRODUCT_MANAGER_POST_PRODUCT_LIST_FAIL,
  PRODUCT_MANAGER_POST_PRODUCT_BEGIN,
  PRODUCT_MANAGER_POST_PRODUCT_SUCCESS,
  PRODUCT_MANAGER_POST_PRODUCT_FAIL,
} from '../../actions/productManagerListAction';

const INITIAL_STATE = {
  data: {
    //
  },
  status: 'uninitialized',
};

export default function productManagerListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case PRODUCT_MANAGER_LIST_INIT:
      return { ...INITIAL_STATE, status: 'editing' };

    case PRODUCT_MANAGER_GET_PRODUCT_LIST_BEGIN:
      return { ...state, status: 'fetching' };

    case PRODUCT_MANAGER_GET_PRODUCT_LIST_SUCCESS:
      return update(state, {
        data: { $set: action.data },
        total: { $set: action.total },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_GET_PRODUCT_LIST_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_POST_PRODUCT_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_POST_PRODUCT_SUCCESS:
      return update(state, {
        data: { $unshift: [action.data] },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_POST_PRODUCT_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_POST_PRODUCT_LIST_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_POST_PRODUCT_LIST_SUCCESS:
      return update(state, {
        data: { $set: action.data },
        total: { $set: action.total },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_POST_PRODUCT_LIST_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    default:
      return state;
  }
}
